<template>
  <div>
    <div class="modal__content">
      <p class="text-center mb20">Are you sure you want to remove {{args.userEmail}}?</p>

      <div class="flex flex--justify-center">
        <button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
        <button class="btn btn--wide" @click="onConfirm">Yes</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {}
    },

    props: {
      args: {
        type: Object,
        required: true
      }
    },

    created () {
    },

    methods: {
      onConfirm () {
        this.$bus.$emit('userRemove', this.args.userId)
        this.$bus.$emit('loaderShow')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemoveUserModal.vue?66caa665